// Requester Container table for requester final all in one
import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Input from '../../Shared/Input';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import '../../../css/MarketPlace/QuotationContainerDetails.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import arrowup from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import arrowdown from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import search from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import ContainerDetailesData from '../../../Data/MarketPlace/ResponseContainerDetails.json';
import {
    ContainerSourceAlphaAscendingSorting, ContainerSourceAlphaDescendingSorting,
    ContainerDestinationAlphaAscendingSorting, ContainerDestinationAlphaDescendingSorting,
    ContainerStatusAlphaAscendingSorting, ContainerStatusAlphaDescendingSorting
} from '../../../Services/utils/AlphaSorting';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_REQUESTER_CONTAINER_ENDPOINT, SERVICE_CANCELLATION_POLICY_ENDPOINT } from '../../../Services/config/apiEndPoints';
class QuotationContainerDetails extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            viewCase: false,
            hasOpen: false,
            StarRated: '',
            StarRating: '',
            requestResponse: false,
            requestDataFlag: false,
            enterContainerDetails: true,
            PickupLocation: '',
            containerNoValue: [],
            hideButton: false,
            containerTableDataShow: [],
            ContainerNumber: '',
            searchContainerNumberlength: 0,
            ContainerNumberSearcheddata: [],
            noOfContainer: '',
            source: '',
            destination: '',
            truckTypeRequirements: '',
            serviceIdValue: '',
            serviceNameValue: '',
            tableDetails: [],
            valuesArray: [],
            ShowInputContainer: [],
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handlechangesearchContainerNumberID = this.handlechangesearchContainerNumberID.bind(this);
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        const { serviceId, serviceName, containerNo, pickupLocation, destination, truckTypeRequirements } = this.props.match.params;
        this.setState({
            serviceIdValue: serviceId
        })
        if (containerNo && pickupLocation && destination && truckTypeRequirements) {
            this.setState({
                noOfContainer: containerNo,
                source: pickupLocation,
                destination: destination,
                truckTypeRequirements: truckTypeRequirements,
                serviceNameValue: serviceName,
                valuesArray: this.props.history.location.state,
            })
            let count = true;
            if (count) {
                for (let index = 0; index < containerNo; index++) {
                    // our object
                    let my_object = {
                        containerNumber: '',
                        truckType: truckTypeRequirements,
                        source: pickupLocation,
                        destination: destination,
                    };
                    // push the object to Array
                    this.state.tableDetails.push(my_object)
                }
                count = false;
                this.setState({
                    containerTableDataShow: this.state.tableDetails,
                    containerNoValue: this.state.tableDetails
                })
                console.log("MytableData", this.state.tableDetails)
            }
        }
        else {
            this.setState({
                viewCase: true
            })
            this.getContainerDetails(serviceId);
        }
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
        //
        }
    };
    getContainerDetails = (serviceId) => {
        ApiCall(
            'GET',
            serviceBaseURL + SERVICE_CANCELLATION_POLICY_ENDPOINT,
            //  serviceBaseURL + SERVICE_REQUESTER_CONTAINER_ENDPOINT + `?serviceRequestId=${serviceId}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            apiData = [
                {
                    "containerNumber": "detr65656",
                    "source": "Addington",
                    "destination": "Bayhead",
                    "truckType": "Transporter Assigned"
                },
                {
                    "containerNumber": "",
                    "source": "Pddington",
                    "destination": "Aayhead",
                    "truckType": "Da Transporter Assigned"
                }, {
                    "containerNumber": "5656fgft",
                    "source": "Mddington",
                    "destination": "Zayhead",
                    "truckType": "Is Transporter Assigned"
                },
                {
                    "containerNumber": "MRSU3562332",
                    "source": "Cddington",
                    "destination": "Vayhead",
                    "truckType": "FTransporter Assigned"
                },
                {
                    "containerNumber": "MRSU3562332",
                    "source": "Bddington",
                    "destination": "Baayhead",
                    "truckType": "Transporter Assigned"
                }
            ]
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!', apiData);
                    this.setState({
                        containerNoValue: apiData,
                        containerTableDataShow: apiData,
                        tableDetails: apiData
                    })
                    console.log('abc--', this.state.containerTableDataShow)
                }
            }
        });
    }
    updateContainerDetails = () => {
        ApiCall(
            'PUT',
            serviceBaseURL + SERVICE_REQUESTER_CONTAINER_ENDPOINT + `?serviceRequestId=${this.state.serviceIdValue}`,
            {
                "serviceRequestId": this.state.serviceIdValue,
                "containers": this.state.containerNoValue
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    this.props.history.push({
                        pathname: `/QuotationHistory`
                    })
                }
            }
        });
    }
    addContainerDetails = () => {
        ApiCall(
            'POST',
            serviceBaseURL + SERVICE_REQUESTER_CONTAINER_ENDPOINT + `?serviceRequestId=${this.state.serviceIdValue}`,
            {
                "serviceRequestId": this.state.serviceIdValue,
                "containers": this.state.containerNoValue
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                    this.props.history.push({
                        pathname: `/CreateTransportationService/${this.state.serviceIdValue}/${this.state.serviceNameValue}`,
                        state: this.state.valuesArray
                    })
                }
            }
        });
    }
    handleSubmitDetails = () => {
        if (this.state.viewCase) {
            this.updateContainerDetails();
        }
        else {
            this.addContainerDetails();
        }
    }
    updateRating(index) {
        this.setState({ StarRated: index + 1 });
    }
    updateStarRating(index) {
        this.setState({ StarRating: index + 1 });
    }
    onSubmitModal = () => {
        this.setState({ hasOpen: false })
    }
    onClickEnterContainerDetails = () => {
        this.setState({ enterContainerDetails: !this.state.enterContainerDetails })
    }
    onSortingSource = (e) => {
        if (e == "ascending") {
            this.setState({
                containerTableDataShow: ContainerSourceAlphaAscendingSorting(this.state.containerTableDataShow),
                containerNoValue: ContainerSourceAlphaAscendingSorting(this.state.containerNoValue)
            })
        } else if (e == "descending") {
            this.setState({
                containerTableDataShow: ContainerSourceAlphaDescendingSorting(this.state.containerTableDataShow),
                containerNoValue: ContainerSourceAlphaDescendingSorting(this.state.containerNoValue)
            })
        }
    }
    onSortingDestination = (e) => {
        if (e == "ascending") {
            this.setState({
                containerTableDataShow: ContainerDestinationAlphaAscendingSorting(this.state.containerTableDataShow),
                containerNoValue: ContainerDestinationAlphaAscendingSorting(this.state.containerNoValue)
            })
        } else if (e == "descending") {
            this.setState({
                containerTableDataShow: ContainerDestinationAlphaDescendingSorting(this.state.containerTableDataShow),
                containerNoValue: ContainerDestinationAlphaDescendingSorting(this.state.containerNoValue)
            })
        }
    }
    onSortingStatus = (e) => {
        if (e == "ascending") {
            this.setState({
                containerTableDataShow: ContainerStatusAlphaAscendingSorting(this.state.containerTableDataShow)
            })
        } else if (e == "descending") {
            this.setState({
                containerTableDataShow: ContainerStatusAlphaDescendingSorting(this.state.containerTableDataShow)
            })
        }
    }
    searchContainerNumber = () => {
        if (this.state.ContainerNumber.length > 0) {
            const datafilter = ContainerDetailesData?.filter(i => i?.containerNumber == this.state.ContainerNumber)
            this.setState({ containerTableDataShow: datafilter });
        }
    }
    handlechangesearchContainerNumberID = (e) => {
        this.setState({
            ContainerNumber: e.target.value,
            searchContainerNumberlength: e.target.value.length
        });
    };
    render() {
        if (this.state.searchContainerNumberlength == 0) {
            this.state.containerTableDataShow = this.state.tableDetails;
        }
        return (
            <div class="QuotationCDetailsOutercolor">
                <MetaDecorator title={TitleDescription.ResponseContainerDetailsTitle} description={TitleDescription.ResponseContainerDetailsDescription} />
                <Header tilesFetched={() => { }} />
                <div class="QuotationCDetailsOuterDivcss">
                    <div id="QuotationCDetailsBoxDiv">
                        <nav class="QuotationCDetailsNavbar">
                            <div className="QuotationCDetailsNavbarName">
                                <small id="QuotationCDetailsNavbarText">Container Details</small>
                            </div>
                            {!this.state.hideButton &&
                                <div id="QuotationCDetailsAcceptMobile" className="QuotationCDetailsNavbarNameRight">
                                    <small
                                        class={this.state.enterContainerDetails ? "QuotationCDetailsNavbarRightText" : "QuotationCDetailsNavbarGrayRightText"}
                                        onClick={this.onClickEnterContainerDetails}>
                                        Enter Container Details
                                </small>
                                </div>
                            }
                        </nav>
                        <hr class="hr1" />
                        {!this.state.hideButton && <>
                            <nav class="QuotationCDetailsMobileNavbar">
                                <div className="QuotationCDetailsNavbarNameRight">
                                    <small
                                        class={this.state.enterContainerDetails ? "QuotationCDetailsNavbarRightText" : "QuotationCDetailsNavbarGrayRightText"}
                                        onClick={this.onClickEnterContainerDetails}>
                                        Enter Container Details
                                </small>
                                </div>
                            </nav>
                            <hr class="hrCDMobile" />
                        </>}
                        <div class="QuotationCDetailsMidPartition">
                            <div class="QuotationCDetailsMainDiv">
                                <div class="QuotationCDetailsTableDiv">
                                    <table class="QuotationCDetailsTable">
                                        <thead id="QuotationCDetailsTabalHeadDiv">
                                            <tr id="QuotationCDetailsTableHeadRowCmnCss">
                                                <div id="QuotationCDetailsHeadCol1">
                                                    <div>
                                                        <div className="pass-wrapper" id="QuotationCDetailsRmodalInpDiv" >
                                                            <Input
                                                                class placeholder="Container No."
                                                                type="text" id="QuotationCDetailsRmodalInpConCss" value={this.state.ContainerNumber}
                                                                onChange={this.handlechangesearchContainerNumberID}
                                                            />
                                                            <img onClick={this.searchContainerNumber} id="QuotationCDetailsRmodalSearchCon_imgcss" src={search}></img>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id="QuotationCDetailscol2Headcss">
                                                    <div class="QuotationCDetailsStatusDiv">
                                                        <div id="QuotationCDetailsTabHeadcoltextCmnCss" class="QuotationCDetailsHeadC1up">Source</div>
                                                        <div class="QuotationCDetailsAccordianDiv">
                                                            <img class="QuotationCDetailsAccordianupimg" onClick={() => this.onSortingSource("ascending")} src={arrowup} />
                                                            <img class="QuotationCDetailsAccordianimg" onClick={() => this.onSortingSource("descending")} src={arrowdown} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id="QuotationCDetailscolHeadcss" class="QuotationCDetailsTablebodycol6">
                                                    <div class="QuotationCDetailsStatusDiv">
                                                        <div id="QuotationCDetailsTabHeadcoltextCmnCss" class="QuotationCDetailsHeadC1up">Destination</div>
                                                        <div class="QuotationCDetailsAccordianDiv">
                                                            <img class="QuotationCDetailsAccordianupimg" onClick={() => this.onSortingDestination("ascending")} src={arrowup} />
                                                            <img class="QuotationCDetailsAccordianimg" onClick={() => this.onSortingDestination("descending")} src={arrowdown} />
                                                        </div>
                                                    </div>
                                                </div>
                                                {this.state.requestDataFlag &&
                                                    <div id="QuotationCDetailscolHeadcss" class="QuotationCDetailsTablebodycol10">
                                                        <div id="QuotationCDetailsTabHeadcoltextCmnCss">
                                                            <text class="QuotationCDetailsHeadC1up">Request </text>
                                                            <text class="QuotationCDetailsHeadC1low">Closing Date</text>
                                                        </div>
                                                    </div>
                                                }
                                                <div id="QuotationCDetailscolHeadcss" class="QuotationCDetailsTablebodycol6">
                                                    <div id="QuotationCDetailsTabHeadcoltextCmnCss">
                                                        <text class="QuotationCDetailsHeadC1up">Truck Type</text>
                                                        <text class="QuotationCDetailsHeadC1low">Requirements</text>
                                                    </div>
                                                </div>
                                                {this.state.requestResponse &&
                                                    <>
                                                        <div id="QuotationCDetailscolHeadcss" class="QuotationCDetailsTablebodycol11">
                                                            <div id="QuotationCDetailsTabHeadcoltextCmnCss">
                                                                Driver
                                                    </div>
                                                        </div>
                                                        <div id="QuotationCDetailscolHeadcss" class="QuotationCDetailsTablebodycol12">
                                                            <div id="QuotationCDetailsTabHeadcoltextCmnCss">
                                                                Truck
                                                    </div>
                                                        </div>
                                                        <div id="QuotationCDetailscolHeadcss" class="QuotationCDetailsTablebodycol13">
                                                            <div id="QuotationCDetailsTabHeadcoltextCmnCss">
                                                                <text class="QuotationCDetailsHeadC1up">Trip Start</text>
                                                                <text class="QuotationCDetailsHeadC1low">Time</text>
                                                            </div>
                                                        </div>
                                                        <div id="QuotationCDetailscolHeadcss" class="QuotationCDetailsTablebodycol13">
                                                            <div id="QuotationCDetailsTabHeadcoltextCmnCss">
                                                                <text class="QuotationCDetailsHeadC1up">Trip End</text>
                                                                <text class="QuotationCDetailsHeadC1low">Time</text>
                                                            </div>
                                                        </div>
                                                        <div id="QuotationCDetailscolHeadcss" class="QuotationCDetailsTablebodycol13">
                                                            <div id="QuotationCDetailsTabHeadcoltextCmnCss">
                                                                <text class="QuotationCDetailsHeadC1up">Images </text>
                                                                <text class="QuotationCDetailsHeadC1low">by Driver</text>
                                                            </div>
                                                        </div>
                                                        <div id="QuotationCDetailscolHeadcss" class="QuotationCDetailsTablebodycol13">
                                                            <div class="QuotationCDetailsStatusDiv">
                                                                <div id="QuotationCDetailsTabHeadcoltextCmnCss" class="QuotationCDetailsHeadC1up">Status</div>
                                                                <div class="QuotationCDetailsAccordianDiv">
                                                                    <img class="QuotationCDetailsAccordianupimg" onClick={() => this.onSortingStatus("ascending")} src={arrowup} />
                                                                    <img class="QuotationCDetailsAccordianimg" onClick={() => this.onSortingStatus("descending")} src={arrowdown} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody class="CDTBody">
                                            {(this.state.containerTableDataShow.map((Data, index) => {
                                                return (
                                                    <tr class="QuotationCDetailsTablerow" id="QuotationCDetailsTableRowCmnCss">
                                                        <div id="QuotationCDetailsTablebodycol1">
                                                            <div class="QuotationCDetailsTablebodycoldiv">
                                                                <div class="QuotationCDetailsbodyC1left">{index + 1}</div>
                                                                {(this.state.containerTableDataShow[index].containerNumber == "" || this.state.ShowInputContainer[index])
                                                                    ?
                                                                    <div className="pass-wrapper" id="QuotationCDetailsInpDiv" >
                                                                        <Input
                                                                            readOnly={this.state.enterContainerDetails}
                                                                            name="PickupLocation"
                                                                            class="" placeholder="Enter Container"
                                                                            type="text" id="QuotationCDetailsInpCss"
                                                                            value={this.state.containerNoValue[index].containerNumber}
                                                                            onChange={(e) => {
                                                                                this.state.containerNoValue[index].containerNumber = e.target.value;
                                                                                let c = this.state.ShowInputContainer;
                                                                                c[index] = true
                                                                                this.setState({
                                                                                    containerNoValue: this.state.containerNoValue,
                                                                                    ShowInputContainer: c
                                                                                });
                                                                                console.log("ghfghfghf", this.state.containerNoValue[index].containerNumber, index);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    :
                                                                    <div class="QuotationCDetailsbodyCright">
                                                                        <text class="QuotationCDetailsbodyC1up">{Data.containerNumber}</text>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div id="QuotationCDetailsTablebodycol2">
                                                            <div id="QuotationCDetailsTablecoltextCmnCss">{Data.source}</div>
                                                        </div>
                                                        <div id="QuotationCDetailsTablebodycol" class="QuotationCDetailsTablebodycol6">
                                                            <div id="QuotationCDetailsTablecoltextCmnCss">{Data.destination}</div>
                                                        </div>
                                                        {this.state.requestDataFlag &&
                                                            <div id={Data.TruckAppointmentSlot === "Yet to Book" ? "QuotationCDetailsTablebodyYTB" : "QuotationCDetailsTablebodycol"} class="QuotationCDetailsTablebodycol10">
                                                                <div id="QuotationCDetailsTablecoltextCmnCss">{Data.RFQClosingDate}</div>
                                                            </div>
                                                        }
                                                        <div id="QuotationCDetailsTablebodycol" class="QuotationCDetailsTablebodycol6">
                                                            <div id="QuotationCDetailsTablecoltextCmnCss">{Data.truckType}</div>
                                                        </div>
                                                        {this.state.requestResponse &&
                                                            <>
                                                                <div id="QuotationCDetailsTablebodycol" class="QuotationCDetailsTablebodycol11">
                                                                    <div id="QuotationCDetailsTablecoltextCmnCss">
                                                                        {Data.Driver === "Yet to Assign"
                                                                            ?
                                                                            <> <text id="QuotationCDetailsNotYetU">Yet to</text><text id="QuotationCDetailsNotYetL"> Assign</text></>
                                                                            :
                                                                            Data.Driver
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div id="QuotationCDetailsTablebodyView" class="QuotationCDetailsTablebodycol12">
                                                                    <div id="QuotationCDetailsTabHeadcolviewtextCmnCss">
                                                                        {Data.Truck === "Yet to Assign"
                                                                            ?
                                                                            <> <text id="QuotationCDetailsNotYetU">Yet to</text><text id="QuotationCDetailsNotYetL"> Assign</text></>
                                                                            :
                                                                            Data.Truck
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div id="QuotationCDetailsTablebodycol" class="QuotationCDetailsTablebodycol13" >
                                                                    <div id="QuotationCDetailsTablecoltextCmnCss">
                                                                        {Data.TripStartTime === "Yet to Pickup"
                                                                            ?
                                                                            <> <text id="QuotationCDetailsNotYetU">Yet to</text><text id="QuotationCDetailsNotYetL"> Pickup</text></>
                                                                            :
                                                                            Data.TripStartTime
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div id="QuotationCDetailsTablebodycol" class="QuotationCDetailsTablebodycol13">
                                                                    <div id="QuotationCDetailsTablecoltextCmnCss">
                                                                        {Data.TripEndTime === "Yet to Deliver"
                                                                            ?
                                                                            <> <text id="QuotationCDetailsNotYetU">Yet to</text><text id="QuotationCDetailsNotYetL"> Deliver</text></>
                                                                            :
                                                                            Data.TripEndTime
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div id="QuotationCDetailsTablebodyView" class="QuotationCDetailsTablebodycol13" >
                                                                    <div id="QuotationCDetailsTabHeadcolviewtextCmnCss" style={{ color: Data.ImagesbyDriver === "No Images" && "#707070" }}>
                                                                        {Data.ImagesbyDriver}
                                                                    </div>
                                                                </div>
                                                                <div id="QuotationCDetailsTablebodycol" class="QuotationCDetailsTablebodycol13">
                                                                    <div id="QuotationCDetailsTablecoltextCmnCss">{Data.Status}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                    </tr>
                                                );
                                            }))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {!this.state.hideButton &&
                                <div class="QuotationCDetailsBtnDiv">
                                    <Button class="QuotationCDetailsBtncss" onClick={this.handleSubmitDetails}>
                                        <small class="QuotationCDetailsBtntext">Submit Details</small>
                                    </Button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div class="QuotationCDetailsFooterUnfixed">
                    <Footer />
                </div>
                <div class="QuotationCDetailsFooterFixed">
                    <Footer2 />
                </div>
            </div >
        );
    }
}
export default QuotationContainerDetails;